import { render, staticRenderFns } from "./customerUpdateBtnCellRenderer.vue?vue&type=template&id=236edc6c&"
import script from "./customerUpdateBtnCellRenderer.vue?vue&type=script&lang=js&"
export * from "./customerUpdateBtnCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports